(() => {
  const initialize = () => {
    document.querySelectorAll('[data-tp-navigation]').forEach((parent) => {
      if (parent.dataset.tpNavigationReady === 'true') return;
      const details = parent.querySelector('header-menu > details');
      const summary = details?.querySelector(':scope > summary');
      const link = parent.querySelector(':scope > a');
      if (!details || !summary || !link) return;
      parent.dataset.tpNavigationReady = 'true';
      const hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      const close = () => {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      };
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      });
      parent.addEventListener('pointerenter', (event) => {
        if (!hover.matches) return;
        const pointedElement = document.elementFromPoint(event.clientX, event.clientY);
        if (summary.contains(pointedElement)) return;
        open();
      });
      parent.addEventListener('pointerleave', () => {
        if (hover.matches && !parent.contains(document.activeElement)) close();
      });
      parent.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!parent.contains(document.activeElement) && !parent.matches(':hover')) close();
        }, 0);
      });
      link.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        open();
        details.querySelector('a[href]')?.focus();
      });
      parent.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        close();
        summary.focus();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
